import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	teamsType: null,
	error: "",
	loading: false,
};

// ADD_teamsType
export const addTeamsType = createAsyncThunk(
	"teamsType/addTeamsType",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `teamsType`,
				data: {
					...values,
				},
			});
			toast.success("Country of Issue added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Country of Issue try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_teamsType
export const deleteTeamsType = createAsyncThunk(
	"teamsType/deleteTeamsType ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `teamsType/${id}`,
			});

			toast.success("Country of Issue deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Country of Issue try again");
			console.log(error.message);
		}
	}
);

// teamsTypeS
export const getAllTeamsType = createAsyncThunk(
	"teamsType/getAllTeamsType",
	async () => {
		try {
			const { data } = await axios.get(`teamsType`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateTeamsType = createAsyncThunk(
	"teamsType/updateTeamsType",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `teamsType/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Country of Issue updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Country of Issue try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const teamsTypeSlice = createSlice({
	name: "teamsType",
	initialState,
	reducers: {
		clearTeamsType: (state) => {
			state.teamsType = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllTeamsType ======

		builder.addCase(getAllTeamsType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllTeamsType.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllTeamsType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addTeamsType  ======

		builder.addCase(addTeamsType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addTeamsType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addTeamsType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for teamsType ======

		builder.addCase(updateTeamsType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateTeamsType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateTeamsType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteTeamsType  ======

		builder.addCase(deleteTeamsType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteTeamsType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteTeamsType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default teamsTypeSlice.reducer;
export const { clearTeamsType } = teamsTypeSlice.actions;
